import { useContext } from 'react';
import { SearchOptionsContext } from '../../providers/SearchOptions';

/**
 * Hook used to interact with state/methods in the SearchOptionsProvider
 */
export const useSearchOptions = () => useContext(SearchOptionsContext);
